// extracted by mini-css-extract-plugin
export default {"text":"typograf_text__Rm6Tv","word":"typograf_word__vEd0n"};